export default __webpack_public_path__ + "static/project-neonlove-thumbnail-190052a0e2d8ccc41edc662587c842f8.png";